import { Component, OnInit } from '@angular/core';
import { Language, TranslationService } from 'src/app/services/translation.service';

@Component({
	selector: 'app-language-selector',
	templateUrl: './language-selector.component.html',
	styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
	public languages: Language[] = [];
	public selectedLanguage: Language;

	constructor(private translationService: TranslationService) {}

	ngOnInit(): void {
		this.languages = this.translationService.SUPPORTED_LANGUAGES;
		this.selectedLanguage = this.translationService.getCurrentLanguageDetails();
	}

	onLanguageChange(language: Language): void {
		this.selectedLanguage = language;
		this.translationService.setLanguage(language.code);
	}
}
